import * as React from 'react'
// libs
import { useMutation, useQuery } from '@apollo/client/react'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
// graphql
import { POWER_BI_STANDARD_REPORTS_QUERY } from 'graphql/powerBI/queries'
import { POWER_BI_UPDATE_STANDARD_REPORT_MUTATION } from 'graphql/powerBI/mutations'
// types
import { TRefetch } from 'types/refetch'
import { IPowerBiReport, IPowerBiReportResponse, IPowerBiReportsQueryArgs } from 'types/graphql'
// utils
import get from 'lodash/get'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  data: IPowerBiReport[]
  refetch: TRefetch<IPowerBiReportResponse, IPowerBiReportsQueryArgs>
  isLoading: boolean
  totalCount: number
  updateReports: (reportId: string) => void
  isRefetching: boolean
}

export const PowerBIReportsAPIContext = React.createContext<IContext>({} as any)

const PowerBIReportsAPI: React.FC<Props> = ({ children }) => {
  const { page, perPage } = React.useContext(TableManagementContext)

  const { data, networkStatus, refetch } = useQuery(POWER_BI_STANDARD_REPORTS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      filter: {},
      pagination: {
        pageSkip: page * perPage,
        pageTake: perPage
      }
    }
  })

  const [updateReport] = useMutation(POWER_BI_UPDATE_STANDARD_REPORT_MUTATION)

  const updateReports = async (reportId: string) => {
    await updateReport({
      variables: {
        input: {
          reportId
        }
      }
    })
  }

  const powerBIReports = get(data, 'powerBIStandardReports.data', [])
  const totalCount = get(data, 'powerBIStandardReports.pagination.totalCount')

  const value = {
    refetch,
    totalCount,
    updateReports,
    data: powerBIReports,
    isLoading: networkStatus === 1,
    isRefetching: networkStatus === 2
  }

  return <PowerBIReportsAPIContext.Provider value={value}>{children}</PowerBIReportsAPIContext.Provider>
}

export default PowerBIReportsAPI
